var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Container",
    d: "M10.4268 12.7197L10.0732 13.0732L10.4268 12.7197C10.2861 12.579 10.0954 12.5 9.89645 12.5H6C5.17157 12.5 4.5 11.8284 4.5 11V7C4.5 6.17157 5.17157 5.5 6 5.5H14C14.8284 5.5 15.5 6.17157 15.5 7V11.5C15.5 12.0523 15.0523 12.5 14.5 12.5H13.7118C13.3452 12.5 13.0323 12.7651 12.972 13.1267L12.6665 14.9594L10.4268 12.7197Z",
    stroke: "#2E3438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5a001aa9145c593a0a230361cd160f4f.svg";
export { ForwardRef as ReactComponent };